import React, { useState, useEffect } from 'react';
import Img from '../../Assets/homepage3.jpg'

const HomePage3 = () => {
    const [deviceType, setDeviceType] = useState('desktop');
    
    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            if (width < 640) {
                setDeviceType('mobile');
            } else if (width < 1024) {
                setDeviceType('tablet');
            } else {
                setDeviceType('desktop');
            }
        };
        

        checkScreenSize();
        

        window.addEventListener('resize', checkScreenSize);

        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);

 
    const renderMobileView = () => (
        <div className="p-4 bg-[#FFFFFF]">
            <div style={{ color: "#5D2446" }} className="text-[22px] sm:text-[28px] font-medium font-['Bricolage_Grotesque'] inline-block w-full mb-2">
            About 18-wheeler accidents 
            </div>

            <div className="flex flex-col items-center pt-4 gap-6">
                <img
                    src={Img}
                    alt="18-wheeler accident"
                    className="w-full rounded-[30px] shadow-lg h-[250px] object-cover"
                />
                <div className="flex flex-col items-start gap-4 w-full text-left">
                    <p className="!font-['Nunito'] !font-normal text-[15px] sm:text-[16px] leading-[22px] sm:leading-[24px] break-words">
                    18-wheeler accidents in America often cause catastrophic damage due to the immense size and weight of these vehicles, typically weighing up to 80,000 pounds and stretching over 70 feet in length. 
                    </p>
                    <p className="!font-['Nunito'] !font-normal text-[15px] sm:text-[16px] leading-[22px] sm:leading-[24px] break-words">
                    In high-speed or congested traffic conditions, even a minor error can lead to multi-vehicle pileups and widespread damage. Rural highways and interstate routes are especially prone to such crashes, often involving rollover incidents or jack knifing. 
                    </p>
                    <p className="!font-['Nunito'] !font-normal text-[15px] sm:text-[16px] leading-[22px] sm:leading-[24px] break-words">
                    The aftermath typically includes extensive property damage, serious injuries, and major traffic disruptions. Because of the scale and complexity of these collisions, they often require specialized response and investigation to determine causes and improve roadway safety standards for all drivers. 
                    </p>
                </div>
            </div>
        </div>
    );


    const renderTabletView = () => (
        <div className="p-6 bg-[#FFFFFF]">
            <div style={{ color: "#5D2446" }} className="text-[32px] font-medium font-['Bricolage_Grotesque'] inline-block w-full mb-2">
            About 18-wheeler accidents 
            </div>

            <div className="flex flex-col items-center pt-6 px-4 gap-8">
                <img
                    src={Img}
                    alt="18-wheeler accident"
                    className="w-full rounded-[50px] shadow-lg h-[350px] object-cover"
                />
                <div className="flex flex-col items-start gap-4 w-full text-left">
                    <p className="!font-['Nunito'] !font-normal text-[18px] leading-[28px] ">
                    18-wheeler accidents in America often cause catastrophic damage due to the immense size and weight of these vehicles, typically weighing up to 80,000 pounds and stretching over 70 feet in length. 
                    </p>
                    <p className="!font-['Nunito'] !font-normal text-[18px] leading-[28px]">
                    In high-speed or congested traffic conditions, even a minor error can lead to multi-vehicle pileups and widespread damage. Rural highways and interstate routes are especially prone to such crashes, often involving rollover incidents or jack knifing. 
                    </p>
                    <p className="!font-['Nunito'] !font-normal text-[18px] leading-[28px]">
                    The aftermath typically includes extensive property damage, serious injuries, and major traffic disruptions. Because of the scale and complexity of these collisions, they often require specialized response and investigation to determine causes and improve roadway safety standards for all drivers. 
                    </p>
                </div>
            </div>
        </div>
    );


    const renderDesktopView = () => (
        <div className="p-8 bg-[#FFFFFF]">
            <div style={{ color: "#5D2446" }} className="text-[38px] font-medium font-['Bricolage_Grotesque'] inline-block w-full md:w-[819px] mb-2">
            About 18-wheeler accidents 
            </div>

            <div className="flex flex-row items-start pt-[50px] pl-[170px] gap-12">
                <img
                    src={Img}
                    alt="18-wheeler accident"
                    className="w-[35%] rounded-[85px] shadow-lg relative h-[540px] object-cover"
                />
                <div className="flex flex-col items-start gap-4 text-base w-[45%] text-left">
                    <p className="!font-['Nunito'] !font-normal text-[26px] leading-[36px]">
                    18-wheeler accidents in America often cause catastrophic damage due to the immense size and weight of these vehicles, typically weighing up to 80,000 pounds and stretching over 70 feet in length. 
                    </p>
                    <p className="!font-['Nunito'] !font-normal text-[26px] leading-[36px]">
                    In high-speed or congested traffic conditions, even a minor error can lead to multi-vehicle pileups and widespread damage. Rural highways and interstate routes are especially prone to such crashes, often involving rollover incidents or jack knifing. 
                    </p>
                    <p className="!font-['Nunito'] !font-normal text-[26px] leading-[36px]">
                    The aftermath typically includes extensive property damage, serious injuries, and major traffic disruptions. Because of the scale and complexity of these collisions, they often require specialized response and investigation to determine causes and improve roadway safety standards for all drivers. 
                    </p>
                </div>
            </div>
        </div>
    );


    switch (deviceType) {
        case 'mobile':
            return renderMobileView();
        case 'tablet':
            return renderTabletView();
        case 'desktop':
        default:
            return renderDesktopView();
    }
};

export default HomePage3;
